import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import TitleFlip from '../../helpers/TitleFlip';
import { sanitizeHtml } from '@Hotels-at-Home/hah-fe-core/dist/utils';

const MobBathCollectionSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$mobBathSection' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bath' });
  const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });

  return (
    <section className="base-section hp-mobile-viewport mob-bath-collection">
      <h2 className="mob-title">
        <TitleFlip normalText={t('collection')} alternateFlip>
          <span className="accent-bar">
            {t('bath')}
            <em data-gsap="grow" data-gsap-delay="0.06" data-gsap-duration="0.8" />
          </span>
        </TitleFlip>
      </h2>
      <a className="mob-main-section" href={tLink('bath')} id="CTA-bath-mob">
        <picture>
          <source srcSet="/images/homePage/fill.gif" media="(min-width: 801px)" />
          <img
            src="/images/homePage/bathSection/hp-bath-mob.webp"
            alt={t('bath')}
            className="img"
            loading="lazy"
            width="786"
            height="419"
            decoding="async"
            fetchPriority="low"
          />
        </picture>
      </a>
      <div className="shop-list">
        <a className="shop-list-item" href={tLink('robes')} id="CTA-robes-mob">
          <picture>
            <source srcSet="/images/homePage/fill.gif" media="(min-width: 801px)" />
            <img
              src="/images/homePage/bathSection/Marriott-robes_lrg.webp"
              alt={tCommon('productName', { productName: t('robes') })}
              className="img"
              loading="lazy"
              width="786"
              height="419"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <h3
            className="mob-section mob-section-half-width txt"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(t('robes')) }}
          />
        </a>
        <a className="shop-list-item" href={tLink('towels')} id="CTA-towels-mob">
          <picture>
            <source srcSet="/images/homePage/fill.gif" media="(min-width: 801px)" />
            <img
              src="/images/homePage/bathSection/Marriott-towel-set-MAR-320-01-SET-BT-WH_lrg.webp"
              alt={tCommon('productName', { productName: t('towels') })}
              className="img"
              loading="lazy"
              width="786"
              height="419"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <h3
            className="mob-section mob-section-half-width txt"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(t('towels')) }}
          />
        </a>
      </div>
    </section>
  );
};

export default MobBathCollectionSection;
